import React from 'react';

const SvgMv = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect
        id="MV_svg__a"
        x={0}
        y={0}
        width="1em"
        height="1em"
        viewBox="0 0 28 20"
        rx={2}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="MV_svg__b" fill="#fff">
        <use xlinkHref="#MV_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#MV_svg__a" />
      <path fill="#F32249" mask="url(#MV_svg__b)" d="M0 0h28v20H0z" />
      <rect
        fill="#15A04F"
        mask="url(#MV_svg__b)"
        x={4}
        y={4}
        width={20}
        height={12}
        rx={0.667}
      />
      <path
        d="M16.333 5.44a4.668 4.668 0 0 0 0 9.12 4.667 4.667 0 1 1 0-9.119z"
        fill="#FFF"
        mask="url(#MV_svg__b)"
      />
    </g>
  </svg>
);

export default SvgMv;
